<template>
<main>
  <div class="container">
    <div class="row header">
      <div class="col-md-4" style="text-align: left;">
        <div id="last-update">Last Update: {{ lastUpdate }}</div>
      </div>
      <div class="col-md-2">
        <h2>Diabetes</h2>
      </div>
      <div class="col-md-2">
        <h2>Insulin</h2>
      </div>
      <div class="col-md-2">
        <h2>GLP1</h2>
      </div>
      <div class="col-md-2">
        <h2>MOAD</h2>
      </div>
    </div>
    <div class="row region">
      <div class="col-md-4">
        <h3 class="germany">Germany</h3>
      </div>
      <div class="col-md-2">
        <input
          class="form-input"
          type="number"
          min="0.00"
          step="0.01"
          :value="getValue('GERMANY.Diabetes')"
          @input="setValue('GERMANY.Diabetes', $event.target.value)"
        >
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('GERMANY.Insulin')"
        @input="setValue('GERMANY.Insulin', $event.target.value)"
      >
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('GERMANY.GLP1')"
        @input="setValue('GERMANY.GLP1', $event.target.value)"
      >
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('GERMANY.MOAD')"
        @input="setValue('GERMANY.MOAD', $event.target.value)"
      >
      </div>
    </div>
    <div class="row region">
    <div class="col-md-4">
        <h3 class="latam">Latam</h3>
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('LATAM.Diabetes')"
        @input="setValue('LATAM.Diabetes', $event.target.value)"
      >
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('LATAM.Insulin')"
        @input="setValue('LATAM.Insulin', $event.target.value)"
      >
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('LATAM.GLP1')"
        @input="setValue('LATAM.GLP1', $event.target.value)"
      >
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('LATAM.MOAD')"
        @input="setValue('LATAM.MOAD', $event.target.value)"
      >
      </div>
    </div>
    <div class="row region">
    <div class="col-md-4">
        <h3 class="china">China</h3>
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('CHINA.Diabetes')"
        @input="setValue('CHINA.Diabetes', $event.target.value)"
      >
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('CHINA.Insulin')"
        @input="setValue('CHINA.Insulin', $event.target.value)"
      >
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('CHINA.GLP1')"
        @input="setValue('CHINA.GLP1', $event.target.value)"
      >
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('CHINA.MOAD')"
        @input="setValue('CHINA.MOAD', $event.target.value)"
      >
      </div>
    </div>
    <div class="row region">
      <div class="col-md-4">
        <h3 class="japan">Japan</h3>
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('JAPAN.Diabetes')"
        @input="setValue('JAPAN.Diabetes', $event.target.value)"
      >
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('JAPAN.Insulin')"
        @input="setValue('JAPAN.Insulin', $event.target.value)"
      >
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('JAPAN.GLP1')"
        @input="setValue('JAPAN.GLP1', $event.target.value)"
      >
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('JAPAN.MOAD')"
        @input="setValue('JAPAN.MOAD', $event.target.value)"
      >
      </div>
    </div>
    <div class="row region">
      <div class="col-md-4">
        <h3 class="apac">APAC</h3>
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('APAC.Diabetes')"
        @input="setValue('APAC.Diabetes', $event.target.value)"
      >
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('APAC.Insulin')"
        @input="setValue('APAC.Insulin', $event.target.value)"
      >
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('APAC.GLP1')"
        @input="setValue('APAC.GLP1', $event.target.value)"
      >
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('APAC.MOAD')"
        @input="setValue('APAC.MOAD', $event.target.value)"
      >
      </div>
    </div>
    <div class="row region">
      <div class="col-md-4">
        <h3 class="seemea">SEEMEA</h3>
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('SEEMEA.Diabetes')"
        @input="setValue('SEEMEA.Diabetes', $event.target.value)"
      >
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('SEEMEA.Insulin')"
        @input="setValue('SEEMEA.Insulin', $event.target.value)"
      >
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('SEEMEA.GLP1')"
        @input="setValue('SEEMEA.GLP1', $event.target.value)"
      >
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('SEEMEA.MOAD')"
        @input="setValue('SEEMEA.MOAD', $event.target.value)"
      >
      </div>
    </div>
    <div class="row region">
      <div class="col-md-4">
        <h3 class="nwe">NWE</h3>
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('NWE.Diabetes')"
        @input="setValue('NWE.Diabetes', $event.target.value)"
      >
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('NWE.Insulin')"
        @input="setValue('NWE.Insulin', $event.target.value)"
      >
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('NWE.GLP1')"
        @input="setValue('NWE.GLP1', $event.target.value)"
      >
      </div>
      <div class="col-md-2">
      <input
        class="form-input"
        type="number"
        min="0.00"
        step="0.01"
        :value="getValue('NWE.MOAD')"
        @input="setValue('NWE.MOAD', $event.target.value)"
      >
      </div>
    </div>
    <div class="row region" id="total-io">
      <div class="col-md-3">
        <h3 class="total-io">Total IO</h3>
      </div>
      <div class="col-md-1">
        <div class="row">
          <div class="col-md-12">
            <span>MS</span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <span>SoG</span>
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <div class="row">
          <div class="col-md-3">
          <input
            class="form-input"
            type="number"
            min="0.00"
            step="0.01"
            :value="getValue('Total IO.DiabetesMS')"
            @input="setValue('Total IO.DiabetesMS', $event.target.value)"
          >
          </div>
          <div class="col-md-3">
          <input
            class="form-input"
            type="number"
            min="0.00"
            step="0.01"
            :value="getValue('Total IO.InsulinMS')"
            @input="setValue('Total IO.InsulinMS', $event.target.value)"
          >
          </div>
          <div class="col-md-3">
          <input
            class="form-input"
            type="number"
            min="0.00"
            step="0.01"
            :value="getValue('Total IO.GLP1MS')"
            @input="setValue('Total IO.GLP1MS', $event.target.value)"
          >
          </div>
          <div class="col-md-3">
          <input
            class="form-input"
            type="number"
            min="0.00"
            step="0.01"
            :value="getValue('Total IO.MOAD_MS')"
            @input="setValue('Total IO.MOAD_MS', $event.target.value)"
          >
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
          <input
            class="form-input"
            type="number"
            min="0.00"
            step="0.01"
            :value="getValue('Total IO.DiabetesSoG')"
            @input="setValue('Total IO.DiabetesSoG', $event.target.value)"
          >
          </div>
          <div class="col-md-3">
          <input
            class="form-input"
            type="number"
            min="0.00"
            step="0.01"
            :value="getValue('Total IO.InsulinSoG')"
            @input="setValue('Total IO.InsulinSoG', $event.target.value)"
          >
          </div>
          <div class="col-md-3">
          <input
            class="form-input"
            type="number"
            min="0.00"
            step="0.01"
            :value="getValue('Total IO.GLP1SoG')"
            @input="setValue('Total IO.GLP1SoG', $event.target.value)"
          >
          </div>
          <div class="col-md-3">
          <input
            class="form-input"
            type="number"
            min="0.00"
            step="0.01"
            :value="getValue('Total IO.MOAD_SoG')"
            @input="setValue('Total IO.MOAD_SoG', $event.target.value)"
          >
          </div>
        </div>
      </div>
    </div>
    <div class="row region">
      <div class="col-md-12">
        <input
          type="text"
          placeholder="Datasource"
          :value="getDataSource()"
          @input="setDataSource($event.target.value)"
        >
      </div>
    </div>
    <div class="row action-bar">
      <div class="col-md-12" style="text-align: right; margin-top: 1em;">
        <button
          type="submit"
          class="btn btn-primary btn-save"
          :disabled=hasChanges
          @click="save()"
        >Save Data</button>
      </div>
    </div>
  </div>
</main>
</template>

<script>
import DataSetup from '../dataSetup'

export default {
  name: 'MarketForm',

  data () {
    return {
      changed: false
    }
  },

  created () {
    let parsedJsonData = JSON.parse(window.localStorage.getItem('history-wall'))
    if (parsedJsonData) {
      this.dataSource = parsedJsonData.chart.dataSource
      this.data = parsedJsonData.chart.data
      let d = new Date(parsedJsonData.lastupdate)
      var dateString = d.getUTCDate() + '.' + (d.getUTCMonth() + 1) + '.' + d.getUTCFullYear() + ' ' + d.getUTCHours() + ':' + d.getUTCMinutes() + ':' + d.getUTCSeconds()
      this.lastUpdate = dateString
    }
    this.changed = false
  },
  methods: {
    getValue (path) {
      const keys = path.split('.')
      return DataSetup.regionData(this.data, keys[0], keys[1])
    },

    setValue (path, value) {
      this.changed = true
      const keys = path.split('.')
      DataSetup.setRegionData(keys[0], keys[1], value)
    },

    getDataSource () {
      return this.dataSource
    },

    setDataSource (val) {
      this.changed = true
      DataSetup.setDataSource(val)
    },

    save () {
      DataSetup.setUpdateDate()
      DataSetup.saveData()
    }
  },
  computed: {
    hasChanges () {
      return !this.changed
    }
  }
}
</script>

<style scoped>
  #market {
    background-color: #FFFFFF;
    border: 1px solid #CCCCCC;
    padding: 20px;
    margin-top: 10px;
  }
  #last-update {
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/views/market.vue